<template>
	<sf-modal-layout class="qms-xl" :title="rtnPartMstPopupInfo.title" :show="display" :closeModal="close">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-20">
				<template v-if="!isLoading">
					<sf-card class="p-0 border-0 bg-transparent">
						<rtn-part-mst-popup-table-1 ref="tableInfo1" :scrId="scrId" @Refresh="Refresh"> </rtn-part-mst-popup-table-1>
						<rtn-part-mst-popup-table-2 ref="tableInfo2" :scrId="scrId" @Refresh="Refresh"></rtn-part-mst-popup-table-2>
					</sf-card>
				</template>
			</div>
		</div>
	</sf-modal-layout>
</template>
<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';

import RtnPartMstPopupTable1 from './Table/RtnPartMstPopupTable1.vue';
import RtnPartMstPopupTable2 from './Table/RtnPartMstPopupTable2.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		//해당 컴포넌트안에서 사용하는 상태 정의(지역변수)
		return {
			display: false,
			isLoading: false,
			rtnPartMstPopupInfo: {
				title: '', //타이틀명
				roNo: '',
				rptpNo: '',
				aplcId: '',
				aplcDept: ''
			}
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	components: {
		RtnPartMstPopupTable1,
		RtnPartMstPopupTable2
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		Refresh() {
			this.$emit('Refresh');
		},
		async open(param) {
			this.display = true;
			this.isLoading = true;
			this.$sf_toggleLoading(true);

			this.rtnPartMstPopupInfo.title = param.title;
			this.rtnPartMstPopupInfo.roNo = param.roNo;
			let rtnPartMstPopupInfo = this.rtnPartMstPopupInfo;

			//초기화
			this.setRtnPartInfoInit_();
			try {
				if (rtnPartMstPopupInfo.roNo == '' || rtnPartMstPopupInfo.roNo == null) {
					this.$sf_toggleLoading(true);

					await this.setBtnTsAuth_(this.isButton_(this.scrId, 'TS'));
					await this.setBtnApAuth_(this.isButton_(this.scrId, 'AP'));
				} else {
					this.$sf_toggleLoading(true);

					await this.getRtnPartInfo_(rtnPartMstPopupInfo);

					await this.setBtnTsAuth_(this.isButton_(this.scrId, 'TS'));
					await this.setBtnApAuth_(this.isButton_(this.scrId, 'AP'));
					await this.setBtnIcAuth_(this.isButton_(this.scrId, 'IC'));
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.isLoading = false;
				this.$sf_toggleLoading(false);
			}
		},
		close() {
			this.$emit('Refresh');
			this.isLoading = true;
			this.display = false;
		}
	},
	created() {
		console.clear();
	}
};
</script>

<style></style>
